import(/* webpackMode: "eager" */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\about\\membership\\page.tsx");
